import { render, staticRenderFns } from "./QdtComponent.vue?vue&type=template&id=2032babe"
import script from "./QdtComponent.vue?vue&type=script&lang=js"
export * from "./QdtComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports